module.exports = __webpack_public_path__ + "img/classe2.c82d8737.jpg";